import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    class: "siteSearch-hit",
    "data-hit": "generic"
};
const _hoisted_2 = ["href", "title"];
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "the-content" };
const _hoisted_5 = { class: "cardTitle" };
const _hoisted_6 = ["href", "innerHTML", "title"];
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = { class: "the-end" };
import { computed } from 'vue';
import { niceDateFromISO8601 } from '../../../shared';
import { ThemeButton } from '../../../components';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Generic',
    props: {
        document: {}
    },
    setup(__props) {
        const props = __props;
        const elapsedTime = computed(() => niceDateFromISO8601(props.document.published_at));
        return (_ctx, _cache) => {
            var _a, _b;
            return (_openBlock(), _createElementBlock("li", _hoisted_1, [
                _createElementVNode("a", {
                    class: "the-img",
                    href: _ctx.document.url,
                    title: _ctx.$t('search.read_more_about', { title: _ctx.document.title })
                }, [
                    (_ctx.document.thumbnail_url)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.document.thumbnail_url,
                            alt: ""
                        }, null, 8, _hoisted_3))
                        : _createCommentVNode("", true)
                ], 8, _hoisted_2),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h3", _hoisted_5, [
                        _createElementVNode("a", {
                            href: _ctx.document.url,
                            innerHTML: ((_a = _ctx.document._formatted) === null || _a === void 0 ? void 0 : _a.title) || _ctx.document.title,
                            title: _ctx.$t('search.read_more_about', { title: _ctx.document.title })
                        }, null, 8, _hoisted_6)
                    ]),
                    _createElementVNode("div", {
                        class: "excerpt",
                        innerHTML: ((_b = _ctx.document._formatted) === null || _b === void 0 ? void 0 : _b.excerpt) || _ctx.document.excerpt
                    }, null, 8, _hoisted_7)
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _createVNode(_unref(ThemeButton), {
                        "wca-title": _ctx.$t('search.read_more_about', { title: _ctx.document.title }),
                        icon: "arrow-right-long",
                        type: "link",
                        href: _ctx.document.url
                    }, null, 8, ["wca-title", "href"])
                ])
            ]));
        };
    }
});
